module.exports = __webpack_public_path__ + "static/media/SHSProdIcons_Pill_Speaker.e4d01012.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/homepage/resources/SHSProdIcons_Pill_Speaker.svg
// module id = 3545
// module chunks = 0